var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"chip--select-multi",attrs:{"close":_vm.close,"value":_vm.value},on:{"click:close":function($event){return _vm.$emit('click:close', _vm.value)}}},[_c('v-avatar',{class:[_vm.chipColor, _vm.small ? 'small' : '']},[_c('img',{attrs:{"src":_vm.avatarData}})]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }